<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import TableFilterButton from './TableFilterButton.vue'
import TableDownloadButton from './TableDownloadButton.vue'

export default {
  components: { TableDownloadButton, TableFilterButton },
  mixins: [mixinComponent],

  props: {
    filtersToggle: {
      type: Boolean,
      default: true,
    },
    downloadToggle: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    download() {
      this.$emit('download')
    },
    toggleCollapse() {
      this.$emit('toggle-collapse')
    },
  },
}
</script>
<template>
  <div class="d-flex align-items-center justify-content-center">
    <TableFilterButton v-if="filtersToggle" class="mr-2" @toggle-collapse="toggleCollapse" />
    <TableDownloadButton v-if="downloadToggle" @download="download" />
  </div>
</template>
